const fontWeights = {
    '$font-weight-normal': '400',
    '$font-weight-semi-bold': '500',
    '$font-weight-bold': '600',
};


export default fontWeights;
